@charset "UTF-8";

/* src/app/modules/print-cards/components/print-labels/label-content/custom-labels-2x4/brand-inventory-label-stack-content/brand-inventory-label-stack-content.component.scss */
.f12px {
  font-size: 0.75rem;
}
.f14px {
  font-size: 0.875rem;
}
.f16px {
  font-size: 1rem;
}
.f18px {
  font-size: 1.125rem;
}
.f20px {
  font-size: 1.25rem;
}
.f24px {
  font-size: 1.5rem;
}
.f32px {
  font-size: 2rem;
}
.f48px {
  font-size: 3rem;
}
.f64px {
  font-size: 4rem;
}
.brand-label {
  height: 100%;
  width: 100%;
  max-height: 100%;
  max-width: 100%;
  box-sizing: border-box;
  display: flex;
}
.left-side {
  width: 5.625rem;
  min-width: 5.625rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0.75rem 0 0.75rem 0.75rem;
}
.left-side .brand-logo {
  height: 5.625rem;
  width: 5.625rem;
  object-fit: contain;
}
.left-side .product-image {
  height: 3.125rem;
  object-fit: contain;
}
.left-side .wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.left-side .wrapper .classification-letter {
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  border-radius: 50%;
  height: 1.875rem;
  width: 1.875rem;
  line-height: 1;
  font-family: poppins, sans-serif;
  font-weight: 700;
  font-size: 1.25rem;
}
.left-side .product-size {
  font-family: poppins, sans-serif;
  font-style: italic;
  font-weight: 700;
  overflow: clip;
  overflow-clip-margin: 0.1rem;
  text-overflow: ellipsis;
  white-space: normal;
  display: -webkit-box;
  word-break: break-word;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  font-size: 1rem;
  text-align: center;
  line-height: 100%;
}
.splitter {
  min-width: 0.25rem;
  border-radius: 0.25rem;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}
.right-side {
  display: flex;
  align-items: center;
  width: 100%;
}
.right-side .product-name {
  font-family: poppins, sans-serif;
  font-weight: 700;
  overflow: clip;
  overflow-clip-margin: 0.1rem;
  text-overflow: ellipsis;
  white-space: normal;
  display: -webkit-box;
  word-break: break-word;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  font-size: 2rem;
  line-height: 110%;
}
/*# sourceMappingURL=brand-inventory-label-stack-content.component.css.map */
